export const buildFavoriteFoodPayload = ({ food, displayName, sourceData }) => {
  const fallbackName = String(displayName || '').trim() || 'Aliment';
  const name = String(food?.name || sourceData?.product_name || sourceData?.product_name_fr || fallbackName).trim() || 'Aliment';
  const brand = String(
    sourceData?.brands
    || sourceData?.brand
    || food?.brand
    || food?.brands
    || ''
  ).trim();
  const code = String(food?.barcode || food?.code || '').trim();

  return {
    name,
    brand,
    code,
  };
};

export const matchesFavoriteFood = (favorite, payload) => {
  if (!favorite || !payload) {
    return false;
  }

  const sameName = String(favorite.name || '').trim().toLowerCase() === String(payload.name || '').trim().toLowerCase();
  const sameBrand = !payload.brand || !String(favorite.brand || '').trim()
    ? true
    : String(favorite.brand || '').trim().toLowerCase() === String(payload.brand || '').trim().toLowerCase();
  const sameCode = !payload.code || !String(favorite.code || '').trim()
    ? true
    : String(favorite.code || '').trim() === String(payload.code || '').trim();

  return sameName && sameBrand && sameCode;
};
